import React, { Component } from "react";
import "../../../../services/complianceAPIServices";
import AttestModalForm1 from "./attestModalForm1";
import AttestModalForm2 from "./attestModalForm2";
import Modal from "../../../common/Modal";

export default class AttestModal extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.currentYear = new Date().getFullYear();
    this.lastStep = 2;
    this.state = {
      step: 1,
      data: {
        "client-name": this.props.quickAttest ? "" : this.props.accountName,
        "group-id": this.props.groupId ? this.props.groupId : "",
        "review-date": new Date().toISOString().split("T")[0],
        "review-structure": "",
        "reviewed-this-year": "Yes",
        "account-substantial-change": "",
        "account-r-t-a-changes": "",
        "reg-b-i-changes": "",
        accounts: [],
        "shared-accounts": [],
      },
      reviewConduct: [
        "In Person",
        "Telephone Conference Call",
        "Video Conference Call",
        "Remote Survey",
        "Other",
      ],
      firstDate: this.props.gracePeriod
        ? new Date(this.currentYear - 1, 0, 1).toLocaleDateString()
        : new Date(this.currentYear, 0, 1).toLocaleDateString(),
      lastDate: this.props.gracePeriod
        ? new Date(this.currentYear - 1, 11, 31).toLocaleDateString()
        : new Date(this.currentYear, 11, 31).toLocaleDateString(),
      elevated: false,
      accounts: [],
      "shared-accounts": [],
      nextDisabled: true,
      pulseOn: true,
      prevCurr: this.props.gracePeriod ? "Previous Year" : "Current Year",
      graceNeeded: true,
      scrollPosition: 0,
    };
  }

  handleYearChange = (e) => {
    if (e.target.value === "Previous Year") {
      this.setState({
        prevCurr: e.target.value,
        firstDate: new Date(this.currentYear - 1, 0, 1).toLocaleDateString(),
        lastDate: new Date(this.currentYear - 1, 11, 31).toLocaleDateString(),
      });
    } else {
      this.setState({
        prevCurr: e.target.value,
        firstDate: new Date(this.currentYear, 0, 1).toLocaleDateString(),
        lastDate: new Date(this.currentYear, 11, 31).toLocaleDateString(),
      });
    }
    this.handleSubmitValidation();
  };

  componentDidMount = () => {
    this._isMounted = true;
    if (this.props.gracePeriod) {
      this.handleIfGraceIsNeeded();
    }
    this.handleElevatedState();
    this.handleAccountsView();
    let position = this.props.GetScrollPosition();
    this.setState({ scrollPosition: position });
    setTimeout(() => {
      this.setState({ pulseOn: false });
    }, 3000);
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  handleIfGraceIsNeeded = () => {
    if (this._isMounted) {
      const { data, clients } = this.props;
      let trueCount = 0;
      let accountCount = 0;
      let noPrevious = false;
      let currentMonth = new Date().getMonth();
      clients.forEach((c) => {
        if (data["client-name"] === c["client-name"]) {
          if (
            Object.keys(c.accounts["Previous"]).length <= 0 ||
            (Object.keys(c.accounts["Current"]).length > 0 && currentMonth > 0)
          ) {
            noPrevious = true;
            this.setState({
              graceNeeded: false,
              firstDate: new Date(this.currentYear, 0, 1).toLocaleDateString(),
              lastDate: new Date(this.currentYear, 11, 31).toLocaleDateString(),
              prevCurr: "Current Year",
            });
          }
          Object.keys(c.accounts["Previous"]).forEach((accountType) => {
            c.accounts["Previous"][accountType].forEach((accountItem) => {
              accountCount = accountCount + 1;
              if (
                clients[clients.indexOf(c)].accounts["Previous"][accountType][
                  c.accounts["Previous"][accountType].indexOf(accountItem)
                ].submitted === "true"
              ) {
                trueCount = trueCount + 1;
              }
            });
          });
        }
      });
      if (noPrevious || (trueCount === accountCount && trueCount > 0)) {
        this.setState({
          graceNeeded: false,
          firstDate: new Date(this.currentYear, 0, 1).toLocaleDateString(),
          lastDate: new Date(this.currentYear, 11, 31).toLocaleDateString(),
          prevCurr: "Current Year",
        });
        return true;
      }
      return false;
    }
  };

  handleAccountsView = () => {
    let history = this.props.data.history;
    let accounts = this.props.data.accounts;
    if (history.length > 20) {
      history = history.splice(0, 19);
    }
    history.forEach((h) => {
      if (
        h["review-date"].includes(new Date(this.state.firstDate).getFullYear())
      ) {
        if (h["accounts"] && h["accounts"].length > 0) {
          h["accounts"].forEach((account) => {
            accounts.splice(accounts.indexOf(account), 1);
          });
        }
      }
    });
  };

  handleElevatedState = () => {
    if (
      this._isMounted &&
      (!this.props.groups.includes("system_admin") ||
        !this.props.groups.includes("compliance"))
    ) {
      this.setState({ elevated: true });
    }
  };

  handleDataUpdate = async (key, value) => {
    await this.handleDataUpdatePart(key, value);
    await this.handleSubmitValidation();
  };

  handleDataUpdatePart = async (key, value) => {
    this.setState((prevState) => {
      return {
        data: {
          ...prevState.data,
          [key]: value,
        },
      };
    });
  };

  handleDataAccountsCheck = (uniqueID) => {
    let accounts = this.state.data.accounts;
    const indexOfUniqueID = accounts.indexOf(uniqueID);
    // if it already exists remove the item
    if (indexOfUniqueID !== -1) {
      accounts.splice(indexOfUniqueID, 1);
      this.setState((prevState) => {
        return {
          data: {
            ...prevState.data,
            accounts: accounts,
          },
        };
      });
    } else {
      // if it does not exist add the item
      this.setState((prevState) => {
        return {
          data: {
            ...prevState.data,
            accounts: [...prevState.data.accounts, uniqueID],
          },
        };
      });
      accounts = [...accounts, uniqueID];
    }
    this.handleSubmitValidation();
    this.handleAsyncAccountsValidation(accounts);
  };

  handleSubmitValidation = async () => {
    await this.handleDefaultNextState();
    const { lastDate } = this.state;
    const {
      "reviewed-this-year": reviewedThisYear,
      "review-date": reviewDate,
      "review-structure": reviewStructure,
      "reg-b-i-changes": regBIChanges,
      "account-r-t-a-changes": accountTRChanges,
      "account-substantial-change": accountSubstantialChange,
    } = this.state.data;
    if (this.state.step === 1) {
      if (
        reviewedThisYear !== "" &&
        reviewDate !== "" &&
        reviewStructure !== "" &&
        accountSubstantialChange !== "" &&
        accountTRChanges !== "" &&
        regBIChanges !== "" &&
        new Date(reviewDate).getFullYear() === new Date(lastDate).getFullYear()
      ) {
        this.setState({ nextDisabled: false });
      }
    }
  };

  handleDefaultNextState = async () => {
    this.setState({ nextDisabled: true });
  };

  handleAsyncAccountsValidation = async (accounts) => {
    const { step } = this.state;
    if (step === this.lastStep && accounts.length > 0) {
      this.setState({ nextDisabled: false });
    } else {
      this.setState({ nextDisabled: true });
    }
  };

  // Proceed to the next step
  handleNextStep = (submitData = undefined) => {
    const { step, prevCurr } = this.state;
    const { onSubmit, onClose } = this.props;
    if (step === this.lastStep) {
      onSubmit(
        submitData,
        prevCurr === "Previous Year" ? "Previous" : "Current"
      );
      onClose();
    } else {
      this.setState({ step: step + 1, nextDisabled: true });
    }
  };

  // Go back to previous step
  handlePrevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1, nextDisabled: false });
  };

  handlePage = () => {
    const {
      step,
      reviewConduct,
      data: submitData,
      prevCurr,
      lastDate,
    } = this.state;
    const { "review-date": reviewDate } = this.state.data;
    const { graceNeeded } = this.state;
    const { data, accountName, groupId, quickAttest, clients, gracePeriod } =
      this.props;
    switch (step) {
      default:
        return (
          <AttestModalForm1
            graceNeeded={graceNeeded}
            reviewDate={reviewDate}
            lastDate={lastDate}
            gracePeriod={gracePeriod}
            prevCurr={prevCurr}
            quickAttest={quickAttest}
            clients={clients}
            accountName={accountName}
            reviewConduct={reviewConduct}
            handleDataUpdate={this.handleDataUpdate}
            handleNextStep={this.handleNextStep}
            submitData={submitData}
          />
        );

      case 2:
        return (
          <AttestModalForm2
            gracePeriod={gracePeriod}
            prevCurr={prevCurr}
            accountName={accountName}
            groupId={groupId}
            submitData={submitData}
            data={data}
            clients={clients}
            handleDataUpdate={this.handleDataUpdate}
            handlePrevStep={this.handlePrevStep}
            handleDataAccountsCheck={this.handleDataAccountsCheck}
          />
        );
    }
  };

  render() {
    const { data, onClose, gracePeriod } = this.props;
    const {
      step,
      nextDisabled,
      data: submitData,
      graceNeeded,
      pulseOn,
      prevCurr,
    } = this.state;

    return (
      <Modal show={!!data} onClose={onClose} size="lg">
        <div className="modal-header">
          <h4 className="modal-title">Client Meeting Form:</h4>
          {gracePeriod && graceNeeded && step <= 1 && (
            <div className="mx-auto">
              {pulseOn && (
                <div
                  className="spinner-grow text-primary float-start"
                  role="status"
                >
                  <span className="visually-hidden"></span>
                </div>
              )}
              <select
                className="form-select mx-auto-start"
                aria-label="Select Previous or Current"
                style={{ width: "auto" }}
                onChange={(e) => this.handleYearChange(e)}
                value={prevCurr}
              >
                <option value="Previous Year">Previous Year</option>
              </select>
            </div>
          )}
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">{this.handlePage()}</div>
        <div className="modal-footer">
          {step >= 2 && (
            <button
              type="button"
              className="btn btn-primary float-start"
              onClick={() => this.handlePrevStep()}
            >
              Back
            </button>
          )}
          <button
            style={{ float: "right" }}
            type="button"
            className="btn btn-primary"
            onClick={() => {
              this.handleSubmitValidation();
              this.handleNextStep(submitData);
            }}
            disabled={nextDisabled}
          >
            {step === this.lastStep ? "Submit" : "Next"}
          </button>
          <button
            style={{ float: "right" }}
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </Modal>
    );
  }
}
